import { render, staticRenderFns } from "./SectionCardImage.vue?vue&type=template&id=3eca4667&"
import script from "./SectionCardImage.vue?vue&type=script&lang=ts&"
export * from "./SectionCardImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports